import { selectModalMode } from './selectModalMode';
import { selectIsOfferPreviewOpen } from '../../../Map/selectors';
import { EListingModalMode } from '../../actions/listingModal';
import { IApplicationState } from '../../types/redux';

export const selectIsMapButtonVisible = (state: IApplicationState): boolean =>
  !selectIsOfferPreviewOpen(state) && selectModalMode(state) === EListingModalMode.FULL_SCREEN;
